export function typeMerge(value) {
    return value;
}
/** 判断类型是否为 PromiseLike */
export function isPromiseLike(value) {
    return (value === null || value === void 0 ? void 0 : value.then) instanceof Function;
}
/** 判断类型是否为 true，主要用于 filter 函数 */
export function isTrue(value) {
    return Boolean(value);
}
/** 用来规避 includes 类型限制过于严格的问题 */
export function includes(arr, elem) {
    return arr.includes(elem);
}
